import type { ReactNode } from 'react';

export function Pane({
  title,
  hint,
  action,
  children,
}: {
  title?: ReactNode;
  hint?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="lc-pane">
      {(title || action) && (
        <header className="lc-pane__head">
          <div>
            {title ? <h2 className="lc-pane__title">{title}</h2> : null}
            {hint ? <div className="lc-pane__hint">{hint}</div> : null}
          </div>
          {action}
        </header>
      )}
      {children}
    </section>
  );
}

export function Stack({ children }: { children: ReactNode }) {
  return <div className="lc-stack">{children}</div>;
}

export function SectionLabel({ children }: { children: ReactNode }) {
  return <div className="lc-label">{children}</div>;
}
